import { closeLinkContextMenu, ReplaceLinkHandler } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-mail-strings';

export function getRevertToFullUrlContextMenuItem(
    oldLinkId: string,
    anchorElement: HTMLAnchorElement,
    convertToFullUrlHandler: ReplaceLinkHandler,
    composeId: string
): IContextualMenuItem {
    return {
        name: strings.showOriginalUrl,
        key: 'RevertToFullUrl',
        onClick: () => {
            logUsage('AttachmentLinkViewRevertToFullUrl');
            closeLinkContextMenu();
            convertToFullUrlHandler(anchorElement.href, anchorElement.href);
        },
    };
}
